module.exports = "/images/avatar-s-21.jpg?a6c87117376d50d914274ebbf12211d7";